import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Dialog as MUIDialog,
  DialogContent,
  IconButton,
  Grid,
  Divider,
  Typography,
} from "@mui/material";
import { HighlightOff } from "@mui/icons-material";

import { useAlert, useAxios } from "../../../hooks";
import { ActiveTextEighteen, colors } from "../../css components/Style";
import { PrimaryLoadingButton } from "../../css components/Button";
import AudienceSizeForm from "../superadmin campaign details component/AudienceSizeForm";

export default function ShowAudienceSizeDialog({
  formikProps,
  showAudSize,
  setShowAudSize,
  audienceSize,
  isDisabled,
  channelSectionRef,
  scrollToChannelSection,
  setForceClick,
}) {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();

  const { campaignID } = useParams();

  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setShowAudSize(false);
  };

  const handleCampaignLive = () => {
    setLoading(true);
    axios({
      url: "/campaign/makeCampaignLive",
      method: "POST",
      disableRedirect: true,
      data: {
        campaign_id: parseInt(campaignID),
      },
    }).then((response) => {
      if (response.status) {
        dispatch(
          alert({ type: "success", message: response.message.displayMessage })
        );
        setShowAudSize(false);
        formikProps.setValues((prev) => ({
          ...prev,
          isCampaignLive: true,
          displayStatus: "Go-Live Requested",
        }));
      }
      setLoading(false);
    });
  };
  return (
    <MUIDialog open={showAudSize} onClose={handleClose}>
      <Grid container spacing={4} padding={"8px 24px"}>
        <Grid size={6} alignSelf={"center"}>
          <ActiveTextEighteen color={colors.publicisBlue}>
            Audience Size
          </ActiveTextEighteen>
        </Grid>

        <Grid size={6} alignSelf={"center"} textAlign={"end"}>
          <IconButton>
            <HighlightOff onClick={() => handleClose()} />
          </IconButton>
        </Grid>
      </Grid>

      <Divider />

      <DialogContent style={{ padding: "24px" }}>
        <Grid container spacing={4}>
          {!isDisabled && (
            <Grid size={12}>
              <Typography variant="h6" style={{ display: "flex" }}>
                NOTE: Fill the channel details on campaign details page to make
                the campaign live.{" "}
              </Typography>
            </Grid>
          )}
          <AudienceSizeForm
            campaign={formikProps?.values}
            formikProps={audienceSize}
            component="consumer"
          />
        </Grid>

        {formikProps?.values.status !== "ACTIVE" &&
          !formikProps?.values.isCampaignLive &&
          formikProps.values.campaignStatus !== "Expired" && (
            <Grid container justifyContent={"end"} mt={2}>
              <Grid size="auto" alignSelf={"center"}>
                {!isDisabled && (
                  <Typography
                    variant="h6"
                    onClick={() => {
                      handleClose();
                      setForceClick(false);
                      scrollToChannelSection();
                    }}
                    sx={{
                      marginRight: "8px",
                      cursor: "pointer",
                      color: colors.publicisBlue,
                    }}
                  >
                    Add Channel details{" "}
                  </Typography>
                )}
              </Grid>

              <Grid size="auto">
                <PrimaryLoadingButton
                  variant="contained"
                  loading={loading}
                  disabled={!isDisabled}
                  onClick={handleCampaignLive}
                >
                  Campaign Go Live
                </PrimaryLoadingButton>
              </Grid>
            </Grid>
          )}
      </DialogContent>
    </MUIDialog>
  );
}
